module.exports = __webpack_public_path__ + "static/img/brand_3.3291b41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_3.jpg
// module id = SEy9
// module chunks = 1